import { useState, useEffect } from "react";
import { addDays, format } from "date-fns";
import axios from "axios";

export const useOccupiedSlots = (token) => {
  const [occupiedSlots, setOccupiedSlots] = useState([]);
  const [holidays, setHolidays] = useState([]);
  // Date minimale imposée par le serveur (J+2 ouvrés pour les RDV visio de
  // région). Null = pas de contrainte particulière.
  const [minDate, setMinDate] = useState(null);
  // Fuseaux : les creneaux sont stockes en heure locale de l'expert.
  const [timezone, setTimezone] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;

    const fetchOccupiedSlots = async () => {
      setLoading(true);
      setError(null);
      
      try {
        // Récupérer les créneaux pour les 15 prochains jours (J+1 à J+15)
        const startDate = format(addDays(new Date(), 1), "yyyy-MM-dd");
        const endDate = format(addDays(new Date(), 15), "yyyy-MM-dd");
        
        const response = await axios.get(`/api/folder/occupied-slots/${token}`, {
          params: { startDate, endDate }
        });

        if (response.data && response.data.success) {
          setOccupiedSlots(response.data.occupiedSlots || []);
          setHolidays(response.data.holidays || []);
          setMinDate(response.data.minDate || null);
          setTimezone(response.data.timezone || null);
        } else {
          setOccupiedSlots([]);
          setHolidays([]);
          setMinDate(null);
          setTimezone(null);
        }
      } catch (err) {
        console.error("Erreur lors de la récupération des créneaux occupés:", err);
        setError(err);
        setOccupiedSlots([]);
        setHolidays([]);
        setMinDate(null);
        setTimezone(null);
      } finally {
        setLoading(false);
      }
    };

    fetchOccupiedSlots();
  }, [token]);

  // Fonction pour vérifier si un créneau est occupé
  const isSlotOccupied = (date, time) => {
    const dateStr = format(date, "yyyy-MM-dd");
    return occupiedSlots.some(slot => 
      slot.date === dateStr && slot.time === time
    );
  };

  // Fonction pour vérifier si une date est dans une période de congés
  const isDateInHoliday = (date) => {
    const dateStr = format(date, "yyyy-MM-dd");
    return holidays.some(holiday => {
      return dateStr >= holiday.dateStart && dateStr <= holiday.dateEnd;
    });
  };

  return {
    occupiedSlots,
    holidays,
    minDate,
    timezone,
    loading,
    error,
    isSlotOccupied,
    isDateInHoliday
  };
};